<template>
    <div class="pa-4 text-center">
        <perfect-scrollbar>
        <v-dialog
            v-model="productDialog"
            max-width="700"
            @click:outside="$emit('update:product-dialog',false)" 
        >
        <v-card>
            <v-card-title>
                {{localProduct.id ? 'Edit' : 'Add'}} Product Info - {{localProduct.barcode}}
            </v-card-title>
            
            <v-card-text>
                <v-form
                    ref="productForm"
                >
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                v-model="localProduct.name"
                                label="Name"
                                outlined
                                dense
                                hide-details
                                @change="change('name',$event)"
                                :rules="[validators.required]"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-autocomplete
                                v-model="localProduct.brand"
                                :items="brandOptions"
                                :loading="brandLoading"
                                :search-input.sync="brandSearch"
                                @change="change('brand', $event)"
                                item-text="name"
                                item-value="id"
                                label="Brand"
                                outlined
                                dense
                                hide-details
                                :rules="[validators.required]"
                            >
                            <template v-slot:append-outer>
                                    <v-icon
                                        @click="brandDialog = true"
                                    >{{ icons.mdiPlus }}</v-icon>

                            </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-autocomplete
                                v-model="localProduct.category"
                                :items="categoryOptions"
                                :loading="categoryLoading"
                                :search-input.sync="categorySearch"
                                @change="change('category', $event)"
                                item-text="name"
                                item-value="id"
                                label="Category"
                                outlined
                                dense
                                hide-details
                                :rules="[validators.required]"
                            >
                            <template v-slot:append-outer>
                                    <v-icon
                                        @click="categoryDialog = true"
                                    >{{ icons.mdiPlus }}</v-icon>

                            </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-autocomplete
                                v-model="localProduct.market"
                                :items="marketOptions"
                                :loading="marketLoading"
                                :search-input.sync="marketSearch"
                                @change="change('market', $event)"
                                item-text="name"
                                item-value="id"
                                label="Market"
                                outlined
                                dense
                                hide-details
                                :rules="[validators.required]"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-textarea
                                v-model="localProduct.desc"
                                label="Description"
                                outlined
                                dense
                                hide-details
                                @change="change('desc', $event)"
                            >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                            <v-text-field
                                v-model="localProduct.height"
                                @change="change('height', $event)"
                                label="Height"
                                outlined
                                dense
                                hide-details
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                            <v-text-field
                                v-model="localProduct.width"
                                @change="change('width', $event)"
                                label="Width"
                                outlined
                                dense
                                hide-details
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                            <v-text-field
                                v-model="localProduct.length"
                                @change="change('length', $event)"
                                label="Length"
                                outlined
                                dense
                                hide-details
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row>
                        <v-col
                            cols="12" sm="12" md="12" class="d-flex flex-columns">
                            <h4>Specifications</h4>
                            <v-spacer></v-spacer>
                                <v-btn
                                    outlined
                                    x-small
                                    icon
                                    @click="specsDialog = true"
                                >
                                    <v-icon>{{icons.mdiPlus}}</v-icon>
                                </v-btn>
                        </v-col>
                    </v-row>
                    <v-row
                        class="mt-2"
                    >
                        <v-col
                            cols="12" sm="12" md="12"
                            v-for="spec, index in localProduct.specs"
                            :key="index"
                        >
                            <v-text-field
                                v-model="spec.value"
                                :label="specLabel(spec.specification)"
                                @change="change(spec.value, $event, true, index)"
                                dense
                                outlined
                                hide-details
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row>
                        <v-col cols="12" sm="12">
                            
                            <div class="image-gallery-container pa-0">
                            <h4>Images</h4><span>Click on image to set it to current (blue border = current)</span>
                                <div class="image-gallery">
                                <v-img
                                    v-for="(image, index) in localProduct.images"
                                    :key="index"
                                    :src="image.thumbnail"
                                    max-height="75px"
                                    max-width="75px"
                                    class="thumbnail-image"
                                    @click="imageChange(image)"
                                    :class="{ 'selected': image.is_current == true }"
                                    contain
                                ></v-img>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn
                        text
                        @click="cancel"
                    >
                    Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        @click="saveProduct"
                    >
                        Save
                    </v-btn>
            </v-card-actions>
        </v-card>

        </v-dialog>
    </perfect-scrollbar>
    <v-dialog
        v-model="specsDialog"
        @click:outside="cancelSpec"
        max-width="700px"
    >
        <v-card>
            <v-card-title>Add Spec</v-card-title>
            <v-card-text>
                <div
                    class="d-flex flex-row"
                >
                <v-select
                    v-model="specification.specification"
                    :items="updatedSpecOptions"
                    :loading="specLoading"
                    item-text="name"
                    item-value="id"
                    label="Specification"
                    dense
                    outlined
                    hide-details
                    class="mr-3"
                ></v-select>
                <v-text-field
                    v-model="specification.value"
                    
                    label="Value"
                    dense
                    outlined
                    hide-details
                ></v-text-field>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    small
                    outlined
                    class="mr-2"
                    @click="cancelSpec"
                >Cancel</v-btn>
                <v-btn
                    color="primary"
                    small
                    outlined
                    @click="addSpec"
                >Add</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
    <v-dialog
        v-model="brandDialog"
        @click:outside="cancelBrand"
        max-width="400px"
    >
        <v-card>
            <v-card-title>Add Brand</v-card-title>
            <v-card-text>
                <div
                    class="d-flex flex-row"
                >
                
                <v-text-field
                    v-model="brand"
                    label="Brand Name"
                    dense
                    outlined
                    hide-details
                ></v-text-field>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    small
                    outlined
                    class="mr-2"
                    @click="cancelBrand"
                >Cancel</v-btn>
                <v-btn
                    color="primary"
                    small
                    outlined
                    :loading="brandLoading"
                    @click="addBrandToDB"
                >Add</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
    
    <v-dialog
        v-model="categoryDialog"
        @click:outside="cancelCategory"
        max-width="400px"
    >
        <v-card>
            <v-card-title>Add Category</v-card-title>
            <v-card-text>
                <div
                    class="d-flex flex-row"
                >
                
                <v-text-field
                    v-model="category"
                    label="Category Name"
                    dense
                    outlined
                    hide-details
                ></v-text-field>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    small
                    outlined
                    class="mr-2"
                    @click="cancelCategory"
                >Cancel</v-btn>
                <v-btn
                    color="primary"
                    small
                    outlined
                    :loading="categoryLoading"
                    @click="addCategoryToDB"
                >Add</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
    </div>
    
</template>

<script>
import { ref, watch, onMounted, computed, getCurrentInstance } from '@vue/composition-api'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import { mdiPlus } from '@mdi/js';
import useProduct from '../useProduct'
import { required, requiredArray } from '@core/utils/validation'

export default ({
    components: {
        PerfectScrollbar
    },
    props:{
        productDialog: {
            type: Boolean,
            default: false
        },
        product: {
            type: Object,
            required: true
        }
    },
    setup(props, {emit}) {
        const vm = getCurrentInstance().proxy

        const localProduct = ref({})
        const specsDialog = ref(false)
        const specification = ref({
            specification: "",
            value:""
        })
        
        const brandDialog = ref(false)
        const brand = ref('')
        
        const categoryDialog = ref(false)
        const category = ref('')

        const updatedProduct = ref({})

        const init = () => {
            if (vm.$refs.productForm != undefined) vm.$refs.productForm.resetValidation()
            localProduct.value = JSON.parse(JSON.stringify(props.product))
            updatedProduct.value['barcode'] = props.product.barcode
        }

        const {
            marketLoading,
            marketOptions,
            marketSearch,
            categoryOptions,
            categoryLoading,
            categorySearch,
            brandOptions,
            brandLoading,
            brandSearch,
            specOptions,
            specLoading,
            specSearch,

            fetchBrands,
            fetchMarkets,
            fetchCategories,
            fetchSpecs,
            addBrand,
            addCategory,
        } = useProduct()

        const cancel = () => {
            init()
            emit('update:product-dialog',false)
        }

        const updatedSpecOptions = computed(() => {
            if (localProduct.value.specs != undefined){
                const specList = localProduct.value.specs.map(spec => {
                    return spec.specification
                })
                
                return specOptions.value.filter(item => !specList.includes(item.id));
            }
            return specOptions.value
        })

        const saveProduct = () => {

            const isStepValid = vm.$refs.productForm.validate()
            if (isStepValid){
                const product = JSON.parse(JSON.stringify(updatedProduct.value))
                emit('save', product)
            }

        }

        const imageChange = (image) => {
            image.is_current = !image.is_current
            
            if (updatedProduct.value['images'] == undefined) updatedProduct.value['images'] = [{id: image.id, is_current: image.is_current}]
            else {
                const img = updatedProduct.find(img => img.id === image.id)
                if (img === undefined) updatedProduct.value['images'].push({id: image.id, is_current: image.is_current})
                else img.is_current = image.is_current
            }
        }

        const change = (label, item, specs=false, index=0) => {
            if (specs) updatedProduct.value['specs'][index][label] = item
            else updatedProduct.value[label] = item
        }

        const specLabel = (id) => {
            const foundSpec = specOptions.value.find((item) => item.id === id);
            return foundSpec ? foundSpec.name : undefined;
        }

        const cancelSpec = () => {
            specsDialog.value = false
            specification.value = {
                specification: "",
                value:""
            }
        }

        const cancelBrand = () => {
            brandDialog.value = false
            brand.value = ''
        }


        const cancelCategory = () => {
            categoryDialog.value = false
            category.value = ''
        }

        const addSpec = () => {
            if (localProduct.value.specs == undefined) {
                localProduct.value['specs'] = [
                    specification.value
                ]
            } else {
                localProduct.value.specs.push(specification.value)
            }
            if (updatedProduct.value['specs'] == undefined) updatedProduct.value['specs'] = []
            updatedProduct.value['specs'].push(specification.value)

            cancelSpec()
        }

        

        const addBrandToDB = async () => {
            const newBrand = {}
            newBrand.name = brand.value
            const resp = await addBrand(newBrand)
            cancelBrand()
        }
        

        const addCategoryToDB = async () => {
            const newCategory = {}
            newCategory.name = category.value
            const resp = await addCategory(newCategory)
            cancelCategory()
        }
        
        
        watch(
            () => props.product, 
            () => {
                init()
            }
        )

        onMounted(()=> {
            
            fetchBrands()
            fetchMarkets()
            fetchCategories()
            fetchSpecs()
        })

        return {
            specsDialog,
            specLabel,
            localProduct,
            marketLoading,
            marketOptions,
            marketSearch,
            categoryOptions,
            categoryLoading,
            categorySearch,
            brandOptions,
            brandLoading,
            brandSearch,
            updatedSpecOptions,
            specLoading,
            addSpec,
            cancelSpec,
            specSearch,
            cancel,
            saveProduct,
            change,
            specification,

            brandDialog,
            brand,
            addBrandToDB,
            cancelBrand,

            categoryDialog,
            category,
            addCategoryToDB,
            cancelCategory,
            imageChange,

            icons: {
                mdiPlus
            },

            validators: {
                required
            }
        }
    },
})
</script>

<style lang="css" scoped>

.image-gallery-container {
  overflow: hidden;
}

.image-gallery {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  padding-right: 50px; /* Make room for the fade effect.  Needs to match the width of the pseudo-element */
  margin-top: 10px;
}


.main-image {
  margin-bottom: 20px;
  border: 1px solid #ccc;  /* Optional: Add a border for visual separation */
  border-radius: 4px;
}

.thumbnail-gallery {
  display: flex;
  overflow-x: auto; /* Enable horizontal scrolling */
  -webkit-overflow-scrolling: touch;  /* Smooth scrolling on iOS */
  padding-bottom: 10px; /* Added padding for scrollbar space */
}

.thumbnail-image {
  margin-right: 10px;
  cursor: pointer;
  border: 1px solid transparent; /* Initially transparent border */
  border-radius: 4px;
  transition: border-color 0.2s ease; /* Smooth transition for the border */
}

.thumbnail-image:hover {
  border-color: #999; /* Change border color on hover */
}

.thumbnail-image.selected {
  border-color: #007bff; /* Highlight the selected thumbnail */
}
</style>